// Global Enums
import {
  adminPages,
  adminSections,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Components
import Page from '../../layout/Page';
import AdminRegattaDocumentsSection from '../../sections/AdminDocumentsPageSections/AdminRegattaDocumentsSection';
import AdminChampionshipDocumentsSection from '../../sections/AdminDocumentsPageSections/AdminChampionshipDocumentsSection';

const pageId = adminPages.adminDocumentsPage;

const AdminDocumentsPageView = function () {
  return (
    <Page id={pageId}>
      <>
        <AdminRegattaDocumentsSection id={adminSections[pageId].regattaDocuments} />
        <AdminChampionshipDocumentsSection id={adminSections[pageId].championshipDocuments} />
      </>
    </Page>
  );
};

export default AdminDocumentsPageView;
